import type {
  DiscountLetterFile,
  DiscountLetterSchool,
} from 'tio-data/requests/lpn-discount-letter';

/** Bundled watermarked letter served in demo sessions, which never reach the API. */
export const SAMPLE_DISCOUNT_LETTER_URL = '/assets/lpn/sample-discount-letter.pdf';

/** Stable picker choices paired with the bundled sample letter. */
export const SAMPLE_DISCOUNT_LETTER_SCHOOLS: DiscountLetterSchool[] = [
  { id: 'sample-1', schoolName: 'Sample University' },
  { id: 'sample-2', schoolName: 'Sample Community College' },
  { id: 'sample-3', schoolName: 'Sample Institute of Technology' },
];

/**
 * The bundled sample letter, for demo sessions.
 *
 * @returns the sample PDF bytes and stable download filename
 * @throws Error when the asset cannot be loaded
 */
export async function fetchSampleDiscountLetter(): Promise<DiscountLetterFile> {
  const response = await fetch(SAMPLE_DISCOUNT_LETTER_URL);
  if (!response.ok) {
    throw new Error(`Sample discount letter failed to load (${response.status})`);
  }
  return { blob: await response.blob(), filename: 'sample-tuition-discount-letter.pdf' };
}
